import { IconBase, IconProps, IconWeight } from '@phosphor-icons/react';
import { forwardRef, ReactElement } from 'react';

import { IconType } from './IconTypes';

const Icon: IconType = ({ color }) => (
  <path
    d="M5.25 6.25H4.75V6.75V17.25V17.75H5.25H18.75H19.25V17.25V6.75V6.25H18.75H5.25ZM18.75 5.75H19.25V5.25V4.5C19.25 4.16848 19.1183 3.85054 18.8839 3.61612C18.6495 3.3817 18.3315 3.25 18 3.25H6C5.66848 3.25 5.35054 3.3817 5.11612 3.61612C4.8817 3.85054 4.75 4.16848 4.75 4.5V5.25V5.75H5.25H18.75ZM5.25 18.25H4.75V18.75V19.5C4.75 19.8315 4.8817 20.1495 5.11612 20.3839C5.35054 20.6183 5.66848 20.75 6 20.75H18C18.3315 20.75 18.6495 20.6183 18.8839 20.3839C19.1183 20.1495 19.25 19.8315 19.25 19.5V18.75V18.25H18.75H5.25ZM6 2.75H18C18.4641 2.75 18.9092 2.93437 19.2374 3.26256C19.5656 3.59075 19.75 4.03587 19.75 4.5V19.5C19.75 19.9641 19.5656 20.4092 19.2374 20.7374C18.9092 21.0656 18.4641 21.25 18 21.25H6C5.53587 21.25 5.09075 21.0656 4.76256 20.7374C4.43437 20.4092 4.25 19.9641 4.25 19.5V4.5C4.25 4.03587 4.43437 3.59075 4.76256 3.26256C5.09075 2.93437 5.53587 2.75 6 2.75Z"
    stroke={color}
  />
);

const buildWeights = (color: string) =>
  new Map<IconWeight, ReactElement>([
    ['bold', <Icon color={color} strokeWidth={24} />],
    ['duotone', <Icon color={color} strokeWidth={16} opacity={0.2} />],
    ['fill', <Icon color={color} strokeWidth={16} opacity={1} />],
    ['light', <Icon color={color} strokeWidth={12} />],
    ['thin', <Icon color={color} strokeWidth={8} />],
    ['regular', <Icon color={color} strokeWidth={16} />],
  ]);

export const IPad = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <IconBase
    ref={ref}
    {...props}
    weights={buildWeights(props.color ?? 'currentColor')}
    viewBox="0 0 24 24"
    fill="none"
  />
));

IPad.displayName = 'IPad';
